import clsx from "clsx";

import { DateTimeTz, Icon } from "@web-app/components";
import { OrderScan, OrderTimeline } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";
import { codeFormatLabel } from "@web-app/utils/scannableCode";

import { SCAN_ENTITY_STOPS } from "./codeEntities";

type ScanActivityProps = {
  item: OrderTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
};

function parseScan(value: string): OrderScan | null {
  try {
    return JSON.parse(value) as OrderScan;
  } catch {
    return null;
  }
}

/** A code scanned at a stop ("pickupScan", "dropoffScan"). */
export default function ScanActivity({
  item,
  showTimelineBar,
  timezone,
}: ScanActivityProps) {
  const scan = parseScan(item.updatedValue);
  const stop = SCAN_ENTITY_STOPS[item.entity];

  return (
    <li className="relative flex gap-x-2 md:gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon name="clipboardCheck" className="h-3 md:h-4 text-green-600" />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-[10px] md:text-xs leading-0 md:leading-5 text-gray-500">
        <span className="font-medium text-gray-900">
          Scanned{" "}
          {scan?.code ? (
            <span className="font-mono">{scan.code}</span>
          ) : (
            "a barcode"
          )}
          {stop && ` at ${stop}`}
        </span>
        {scan?.format && <span>{codeFormatLabel(scan.format)}</span>}
        <span className="relative">
          <DateTimeTz
            start={new Date(item.createdAt)}
            timezone={timezone}
            createdBy={item.createdBy?.name}
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
